<template>
  <v-row style="min-height: 100vh">
    <v-col
      md="12"
      sm="12"
      style="
        
          background: rgba(0,167,228,1.000);
          background: -moz-linear-gradient(-45deg, rgba(0,167,228,1.000) 0%, rgba(0,167,228,1.000) 50%, rgba(203,20,38,1) 50%, rgba(203,20,38,1) 100%);
          background: -webkit-gradient(left top, right bottom, color-stop(0%, rgba(0,167,228,1.000)), color-stop(50%, rgba(0,167,228,1.000)), color-stop(50%, rgba(203,20,38,1)), color-stop(100%, rgba(203,20,38,1)));
          background: -webkit-linear-gradient(-45deg, rgba(0,167,228,1.000) 0%, rgba(0,167,228,1.000) 50%, rgba(203,20,38,1) 50%, rgba(203,20,38,1) 100%);
          background: -o-linear-gradient(-45deg, rgba(0,167,228,1.000) 0%, rgba(0,167,228,1.000) 50%, rgba(203,20,38,1) 50%, rgba(203,20,38,1) 100%);
          background: -ms-linear-gradient(-45deg, rgba(0,167,228,1.000) 0%, rgba(0,167,228,1.000) 50%, rgba(203,20,38,1) 50%, rgba(203,20,38,1) 100%);
          background: linear-gradient(135deg, rgba(0,167,228,1.000) 0%, rgba(0,167,228,1.000) 50%, rgba(203,20,38,1) 50%, rgba(203,20,38,1) 100%);
          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#133b7d', endColorstr='#cb1426', GradientType=1 );
        "
    >
      <div>
        <div class="logo-container">
          <img
            src="@/assets/interwhite.svg"
            style="width: 17%; margin-bottom: 5%;"
          />
        </div>

        <div style="min-width: 60% ">
          <div class="login-box-container">
            <div class="login-box">
              <v-card
                :loading="loading"
                elevation="4"
                outlined
                shaped
                style="width: 100%"
              >
                <div style="padding: 30px">
                  <div style="text-align: center; padding-bottom: 30px;">
                    <h1>Recuperacion de contraseña</h1>
                    Introduce el correo electrónico con el que ingresas, y te
                    enviaremos las instrucciones para restablecer tu contraseña.
                  </div>
                  <v-form ref="form" @submit.prevent="submitForm">
                    <h4>Correo:</h4>
                    <v-text-field
                      v-model="email"
                      :rules="emailRules"
                      required
                    ></v-text-field>

                    <div style="text-align: end !important;">
                      <v-btn
                        color="success"
                        class="mr-4"
                        type="submit"
                        :loading="loading"
                        :disabled="isDisabled"
                        style="margin-top: 20px;"
                      >
                        Continuar
                      </v-btn>
                    </div>
                  </v-form>
                </div>
              </v-card>
            </div>
          </div>
        </div>
      </div>
      <div
        class="bradescard-container"
        style=" text-align: end;
            float: none;
            position: absolute;
            right: 0;
            width:23%;
            bottom: 0;
            padding-bottom: 20px;
            padding-right: 1%;
        "
      >
        <img src="@/assets/BRADESCARD_logo_BCO.png" class="bradescard-logo" />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mainAxios } from "@/mainAxios";
export default {
  data() {
    return {
      email: "",
      emailRules: [(v) => !!v || "El correo es requerido"],
      loading: false,
      isDisabled: false,
      counter: 30,
      timer: null,
    };
  },
  methods: {
    async submitForm() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;

      this.loading = true;
      try {
        const input = {
          email: this.email,
          landing: "portal",
        };

        const res = await mainAxios.post("/v1/password/recovery", input);

        if (res.data && res.data.data) {
          this.$toast.success(
            res.data.data.message || "Se envió la solicitud correctamente"
          );

          this.isDisabled = true;
          setTimeout(() => {
            this.$router.push("/");
          }, 2000);
        }
      } catch (err) {
        const msg =
          err.response?.data?.message || err.message || "Ha ocurrido un error";
        this.$toast.error(msg);
      } finally {
        this.loading = false;
      }
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
};
</script>

<style scoped>
@media (max-width: 1000px) {
  .segurify-logo {
    width: 17%;
    padding-bottom: 5%;
  }
  .logo-container {
    text-align: center !important;
  }
  .login-box {
    padding-left: 0% !important;
    padding-right: 0% !important;
  }
  .bradescard-logo {
    width: 50% !important;
  }
  .bradescard-container {
    text-align: center !important;
  }
}
.logo-container {
  text-align: inherit;
}
.login-box {
  width: 30%;
}
.login-box-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
}

.bradescard-logo {
  width: 100%;
}
.bradescard-container {
  text-align: end;
}

.v-application .success {
  background-color: #133b7d !important;
  border-color: #133b7d !important;
}
</style>
